/* Dynamically activate sidebar menu */
const dynamicMenu = function () {
  const addActiveClassToSidebarLink = function (sidebarItem) {
    sidebarItem.addClass('active');
    sidebarItem.parents('.nav-item.has-treeview').addClass('menu-open');
    sidebarItem
      .parents('.nav-item.has-treeview')
      .children('.nav-link')
      .addClass('active');
  };
  const firstPath = window.location.pathname.split('/')[1];
  const firstAndSecondPath = `${window.location.pathname.split('/')[1]}/${
    window.location.pathname.split('/')[2]
  }`;
  const item = $(`.nav-sidebar > .nav-item a[href="/${firstPath}"]`);
  const twoPathItem = $(
    `.nav-sidebar > .nav-item a[href="/${firstAndSecondPath}"]`
  );
  // Will only work if string in href matches the first path in pathname
  addActiveClassToSidebarLink(item);
  // Will only work if string in href matches the first 2 paths in pathname
  addActiveClassToSidebarLink(twoPathItem);
};

document.addEventListener('turbolinks:load', function () {
  // Activate Push Menu Plugin (needs this to work with turbolinks)
  $('.sidebar-toggle-btn').PushMenu();
  // Enable sidebar dynamic menu
  dynamicMenu();
});
